<script setup lang="ts">
import Button from 'primevue/button';
import { SectionIconography } from './SectionIconography';
import { type Relationship } from '@apparatix/schemas/Relationship';
import { useToastNotifications, useUtilities, useRoutingHelpers } from '@apparatix/composables';
import { DetailTabName } from './types';
import { relationshipToCrmDetailRoutes } from '@apparatix/schemas/Routing';

type Props = {
  relationship: Relationship;
  targetTab?: DetailTabName;
  keepCurrentParent?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  targetTab: 'overview',
  keepCurrentParent: true,
});

const { developerWarning } = useUtilities();
const { showError } = useToastNotifications();
const { openCrmDetailFlyout } = useRoutingHelpers();

const onClick = () => {
  try {
    const [parentType, detailType] = relationshipToCrmDetailRoutes.parse(props.relationship);
    openCrmDetailFlyout(parentType, detailType, props.relationship.id, props.targetTab, props.keepCurrentParent);
  } catch (e) {
    developerWarning(true, e, 'throw');
    showError(`Unable to open ${props.relationship?.name}`, `Error opening ${props.relationship?.type}`);
  }
};
</script>
<template>
  <Button
    v-if="props.relationship?.id"
    severity="secondary"
    variant="outlined"
    @click="onClick"
  >
    <div class="flex items-center gap-2">
      <component :is="SectionIconography[props.relationship.type].icon" :color="SectionIconography[props.relationship.type].color" />
      {{ props.relationship.name ?? `Unnamed ${props.relationship.type}` }}
    </div>
  </Button>
</template>
